import React, { useEffect, useState, useRef } from 'react';
import '../../css/editor.css';
import ApiService from '../../../../services/api'
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import  Course from '../../../../media/courses_white.png';
import Add from '../../../../media/add.png';
import QuillEditor from '../../../../services/quill_editor';
import AdminSelect from './admin_select';
import Back from '../../../../media/back.png';
import TinyMCEEditor from '../../../../services/tinymce';
import Timer from '../../../../media/timer_3.png';



const CreateCourse = () => {
  const navigate = useNavigate();
  const [teachersList, setTeachersList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    title: '',
    description: '',
    goals: '',
    audience: '',
    course_structure: '',
    access_restrictions: '',
    certificate: '',
    course_program: '',
    highlighted: false,
    main_img: null,
    teachers: [],
    category: null,
    visibility: true,
    my_total_duration : '',
  });

  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [onCloseAction, setOnCloseAction] = useState(() => () => {});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await ApiService.getTeachers();
        setTeachersList(res);
        const res2 = await ApiService.getCategories();
        setCategoryList(res2);

        if (res2.length > 0 && !form.category) {
         setForm(prev => ({ ...prev, category: res2[0].id })); 
    }
  
      } catch (err) {
        console.error('Errore nel fetch dei dati:', err);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === 'checkbox') {
      setForm((prev) => ({ ...prev, [name]: checked }));
    } else if (type === 'file') {
      setForm((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleQuillChange = (field) => (html) => {
    setForm((prev) => ({ ...prev, [field]: html }));
  };

  const isEmptyQuill = (html) => {
  if (!html) return true;

  const div = document.createElement("div");
  div.innerHTML = html;

  const text = (div.textContent || '')
    .replace(/\u200B/g, '')
    .trim();

  return text.length === 0;
};

  const handleTeachersChange = (e) => {
    const selected = Array.from(e.target.selectedOptions, (option) => Number(option.value));
    setForm((prev) => ({ ...prev, teachers: selected }));
  };

 const handleCategoryChange = (e) => {
  setForm(prev => ({ ...prev, category: Number(e.target.value) }));
 };

  const validate = () => {
    const errs = {};
    if (!form.title.trim()) errs.title = ["Titolo obbligatorio" , true];
    if (isEmptyQuill(form.description.trim())) {errs.description = ["Descrizione obbligatoria", true];}
    if (!form.main_img) errs.main_img = ["Inserisci immagine del corso", true];
    if (form.teachers.length === 0) errs.teachers = ["Seleziona almeno un insegnante" , true];
    
    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    

    try {
      setSaving(true);
      await ApiService.newCourse(form);
      toast.success("Corso creato con successo!");
      
      setForm({
        title: '',
        description: '',
        goals: '',
        audience: '',
        course_structure: '',
        access_restrictions: '',
        certificate: '',
        course_program: '',
        highlighted: false,
        main_img: null,
        teachers: [],
        category: null,
        visibility: true,
        my_total_duration : '',
      });
      navigate('/admin/corsi');
    } catch (err) {
      console.error('Errore durante la creazione:', err);
      if (err.response) {
        console.log('STATUS:', err.response.status);
        console.log('DATA:', err.response.data); 
      }
      
      toast.error("Errore durante la creazione del corso");
    }
    finally {
      setSaving(false);
    }
  };

  const teacherOptions = teachersList.map(t => ({
    value: t.id,
    label: `${t.first_name} ${t.last_name}`
  }));

  const categoryOptions = categoryList.map(c => ({
    value: c.id,
    label: c.name
  }));

  return (
    <form className="editor-form" onSubmit={handleSubmit}>
      <h2><img src={Course} alt="crea corso" className="section-image" /> Crea corso</h2>

      <button
        className="tab-button"
        style={{marginTop:'20px'}}
        onClick={() => navigate(`/admin/corsi`)}
        type='button'
      >
        <img src={Back} alt="Modifica" className="button-image" style={{marginTop:'-2.5px', marginRight:'2.5px'}}/>
        Torna all'elenco dei corsi
      </button>

      <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
  
        <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <input
            type="checkbox"
            name="visibility"
            checked={form.visibility}
            onChange={handleChange}
          />
          Disponibile
        </label>

        <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <input
            type="checkbox"
            name="highlighted"
            checked={form.highlighted}
            onChange={handleChange}
          />
          Evidenziato
        </label>

        <label style={{ display: "flex", alignItems: "center", gap: "8px"}}>
          <img src={Timer}  alt="" style={{ width: 24, height: 24}} />
          <span style={{fontWeight: 400}}>Durata corso: <strong>Non disponibile</strong></span>
        </label>

        <label style={{display: "flex", alignItems: "center", gap: "8px"}}>
          <img src={Timer}  alt="" style={{ width: 24, height: 24}} />
          <span style={{fontWeight: 400}}>Sovrascrivi durata corso:</span>
          <input
            type="number"
            min = {1}
            max= {999}
            name="my_total_duration"
            value={form.my_total_duration}
            onChange={handleChange}
            onWheel={(e) => e.currentTarget.blur()}
            style={{
              width: 45,
              padding: 6,
              borderRadius: 24,
              border: '1px solid #e0e0e0',
              textAlign: 'center',
              marginTop: '7.5px',
              boxShadow: 'none',
              fontWeight: 'bold'
            }}
          />
          ore
        </label>

      </div>

      <label>Titolo *</label>
      <input type="text" name="title" value={form.title} onChange={handleChange} className={`input ${errors.title ? "error" : ""} `} maxLength={250}/>
      {errors.title && <span className='error'>{errors.title}</span>}

      <label>Descrizione *</label>
      <div className={errors.description ? "error" : ""}>
      <TinyMCEEditor
        value={form.description}
        onChange={handleQuillChange('description')}
        placeholder="Scrivi la descrizione del corso"
        className={errors.description ? "error" : ""}
      />
      {errors.description && <span className='error'>{errors.description}</span>}
      </div>

      <label>Obiettivi</label>
      <TinyMCEEditor value={form.goals} onChange={handleQuillChange('goals')} placeholder="Scrivi gli obiettivi" />

      <label>Destinatari</label>
      <TinyMCEEditor value={form.audience} onChange={handleQuillChange('audience')} placeholder="Scrivi i destinatari" />

      <label>Struttura del corso</label>
      <TinyMCEEditor
        value={form.course_structure}
        onChange={handleQuillChange('course_structure')}
        placeholder="Descrivi la struttura del corso"
      />

      <label>Restrizioni di accesso</label>
      <TinyMCEEditor
        value={form.access_restrictions}
        onChange={handleQuillChange('access_restrictions')}
        placeholder="Specifica eventuali restrizioni di accesso"
      />

      <label>Certificato</label>
      <TinyMCEEditor value={form.certificate} onChange={handleQuillChange('certificate')} placeholder="Dettagli sul certificato" />

      <label>Programma del corso</label>
      <TinyMCEEditor
        value={form.course_program}
        onChange={handleQuillChange('course_program')}
        placeholder="Descrivi il programma del corso"
      />

       <div className="attachstyle">
      <label style={{
          display: "inline-block",
          padding: "10px 16px",
          background: "#393939",
          color: "white",
          borderRadius: "8px",
          cursor: "pointer",
          marginTop: "0"
        }}>
        + Immagine corso
      <input type="file" name="main_img" accept="image/*" onChange={handleChange} style={{display: "none"}}/>
      </label>
      {form.main_img && (
        <div className='attachstyle2' style={{padding: "20px"}}>
          <img
            src={URL.createObjectURL(form.main_img)}
            alt="preview"
            style={{ width: "60px", height: "60px", borderRadius: "16px", marginRight:"10px", objectFit:'cover' }}
          />
          {form.main_img.name}
        </div>
      )}
      </div>
       {errors.main_img && <span className='error'>{errors.main_img}</span>}

      <label>Insegnanti *</label>
      <AdminSelect
        options={teacherOptions}
        isMulti={true}
        value={teacherOptions.filter(t =>
          form.teachers.includes(t.value)
        )}
        onChange={(selected) =>
          setForm(prev => ({
            ...prev,
            teachers: selected.map(s => s.value)
          }))
        }
        placeholder="Seleziona insegnanti"
      />
      {errors.teachers && <span className='error'>{errors.teachers}</span>}

      <label>Categoria *</label>
      <AdminSelect
        options={categoryOptions}
        isMulti={false}
        value={categoryOptions.find(c => c.value === form.category) || null}
        onChange={(selected) =>
          setForm(prev => ({
            ...prev,
            category: selected ? selected.value : null
          }))
        }
        placeholder="Seleziona categoria"
      />
      <button disabled={saving} type="submit" style={{ marginTop: "50px" }}>
         <img src={Add} alt="Aggiungi" className="button-image2" />
         {saving ? 'Creazione in corso...' : 'Crea corso'}
        </button>
    </form>
  );
};

export default CreateCourse;